import React from 'react'
import './aboutpolicy.css'

function NediHouseholdItems(){
  return (
    <div className='apparels-household'>
      <h5 className='uni-body' style={{fontSize:'17px'}}>...Nedi Household Items Coming Soon!</h5>

    </div>
  )
}

export default NediHouseholdItems
